import React, {Component} from "react";
import {CancelButton, ConfirmButton} from "../components/BasicButton";

const CANVAS_ID = "prodectCB"
let captureObj

function pasteListener(e) {
    // Handle the event
    if (captureObj && captureObj.retrieveImageFromClipboardAsBlob) {
        captureObj.retrieveImageFromClipboardAsBlob(e, function(imageBlob){
            // If there's an image, display it in the canvas
            if(captureObj && imageBlob){
                captureObj.onImagePasted(imageBlob)
            }
        });
    }
}

export default class PasteImageFromClipboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasImage: false,
        }
        this.onImagePasted = this.onImagePasted.bind(this)
        this.retrieveImageFromClipboardAsBlob = this.retrieveImageFromClipboardAsBlob.bind(this)
    }

    componentDidMount() {
        captureObj = this
        window.addEventListener("paste", pasteListener, false)
    }

    componentWillUnmount() {
        window.removeEventListener("paste", pasteListener, false)
        captureObj = undefined
    }

    /**
     * This handler retrieves the images from the clipboard as a blob and returns it in a callback.
     *
     * @see http://ourcodeworld.com/articles/read/491/how-to-retrieve-images-from-the-clipboard-with-javascript-in-the-browser
     * @param pasteEvent
     * @param callback
     */
    retrieveImageFromClipboardAsBlob(pasteEvent, callback){
        if(!pasteEvent.clipboardData){
            if(typeof(callback) == "function"){
                callback(undefined);
            }
        }

        let items = pasteEvent.clipboardData.items;

        if(items === undefined){
            if(typeof(callback) == "function"){
                callback(undefined)
            }
        }

        for (let i = 0; i < items.length; i++) {
            // Skip content if not image
            if (items[i].type.indexOf("image") === -1) continue;
            // Retrieve image on clipboard as blob
            let blob = items[i].getAsFile();
            if(typeof(callback) == "function"){
                callback(blob);
            }
        }
    }

    onImagePasted(imageBlob) {
        let canvas = document.getElementById(CANVAS_ID)
        let ctx = canvas.getContext('2d')

        // Create an image to render the blob on the canvas
        let img = new Image()

        // Once the image loads, render the img on the canvas
        let self = this
        img.onload = function(){
            // Update dimensions of the canvas with the dimensions of the image
            // Note 'this' is a local function context
            canvas.width = this.width
            canvas.height = this.height
            // Draw the image
            ctx.drawImage(img, 0, 0);
            self.setState({hasImage: true})
        };

        // Crossbrowser support for URL
        let URLObj = window.URL || window.webkitURL

        // Creates a DOMString containing a URL representing the object given in the parameter
        // namely the original Blob
        img.src = URLObj.createObjectURL(imageBlob)
    }

    render() {
        let renderButton = <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={()=> this.props.cancelImport()}
                />
                {this.state.hasImage ? <ConfirmButton
                    label={"Lisää kuva"}
                    action={()=> this.props.addImageFromCanvas(document.getElementById(CANVAS_ID))}
                /> : null}
            </div>
        </footer>

        return <>
            <section>
                <canvas
                    id={CANVAS_ID}
                    style={
                        {
                            background: 'var(--color-gray-20)',
                            maxWidth: window.innerWidth * 80 / 100,
                            maxHeight: window.innerHeight * 80 / 100,
                            width: '100%'
                        }
                    }
                />
                {!this.state.hasImage ? <p className={"text-center"}>Liitä kuva (ctrl-v / command-v)</p> : null}
            </section>
            {renderButton}
        </>
    }
}
